import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OrganizationListIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <path d="M4 6.66663V25.3333h24V6.66663H4Zm5.33333 2.66666V12H6.66667V9.33329h2.66666ZM6.66667 17.3333v-2.6667h2.66666v2.6667H6.66667Zm0 2.6667h2.66666v2.6666H6.66667V20Zm18.66663 2.6666H12V20h13.3333v2.6666Zm0-5.3333H12v-2.6667h13.3333v2.6667Zm0-5.3333H12V9.33329h13.3333V12Z" />
  </Icon>
);

export default memo(OrganizationListIcon);
